import { Grid } from '@mui/material';
import { PmiButton } from 'shell/components/shared/button';
import PmiTextField from 'shell/components/shared/text-field';
import { memo, useMemo } from 'react';
import { useFormik } from 'formik';
import SelectAnnotation from '../select-annotation';
import createSchema from './schema';
import { Card } from '@mui/material';
import { CardContent } from '@mui/material';
import { Typography } from '@mui/material';
import { CardActions } from '@mui/material';
export interface AnnotationFormVM {
  annotation: string;
  note: string;
}

interface CardAnnotationFormProps {
  onSubmit: (values: AnnotationFormVM) => void;
  disabled?: boolean;
  initialValues?: AnnotationFormVM | null;
  type: string;
  onClose: () => void;
  isEdit?: boolean;
}

const CardAnnotationFormComponent = ({
  type,
  onSubmit,
  initialValues,
  disabled,
  onClose,
  isEdit,
}: CardAnnotationFormProps): React.ReactElement => {
  const validationSchema = useMemo(() => {
    createSchema(isEdit);
  }, [isEdit]);

  const formik = useFormik({
    initialValues: initialValues || {
      annotation: '',
      note: '',
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      const noteAnnotation = values.note?.replaceAll('_', '');
      onSubmit({
        ...values,
        note: noteAnnotation,
      });
    },
  });

  return (
    <Card raised className="pmi-my-3">
      <CardContent style={{ padding: '24px' }}>
        <Typography gutterBottom variant="h5" component="h2">
          Annotazione
        </Typography>
        <div style={{ padding: '24px 0 0 0' }}>
          <Grid container spacing={2}>
            {!isEdit ? (
              <Grid item container xs={12} spacing={2}>
                <Grid item xs={12}>
                  <SelectAnnotation
                    id="annotation"
                    value={formik.values?.annotation || ''}
                    disabled={disabled}
                    onChange={(event, item) =>
                      formik.setValues({
                        annotation: event?.target.value,
                        note: item?.description || '',
                      })
                    }
                    error={formik.touched?.annotation && Boolean(formik.errors?.annotation)}
                    type={type}
                  />
                </Grid>
              </Grid>
            ) : undefined}
            <Grid item container xs={12} spacing={2}>
              <Grid item xs={12}>
                <PmiTextField
                  id="note"
                  fullWidth
                  multiline
                  rows={5}
                  disabled={disabled}
                  inputProps={{
                    maxLength: '1024',
                  }}
                  value={formik.values?.note || ''}
                  onChange={(event) => formik.setFieldValue('note', event?.target.value)}
                  error={formik.touched?.note && Boolean(formik.errors?.note)}
                  helperText={formik.errors?.note}
                />
              </Grid>
            </Grid>
          </Grid>
        </div>
      </CardContent>
      <CardActions style={{ padding: '24px 24px 16px 24px' }}>
        <PmiButton variant="contained" color="primary" onClick={() => formik.handleSubmit()}>
          Conferma
        </PmiButton>
        <PmiButton variant="outlined" color="cdmBrand" onClick={onClose}>
          Annulla
        </PmiButton>
      </CardActions>
    </Card>
  );
};

CardAnnotationFormComponent.displayName = 'Card Annotation form component';

const CardAnnotationForm = memo(CardAnnotationFormComponent);

export default CardAnnotationForm;
